var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApprove(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 6")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Scheduling-/new-shift/Scheduling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-Scheduling-/new-shift/icons",
    transform: "translate(-434.000000, -164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(435.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#44D7B6",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2104042,14.496274 L11.2014042,14.506274 C11.0004042,14.696274 10.6914042,14.696274 10.4914042,14.496274 L8.14040417,12.106274 C7.95140417,11.906274 7.95140417,11.586274 8.15140417,11.396274 C8.35140417,11.196274 8.66140417,11.206274 8.86140417,11.396274 L10.8514042,13.426274 L15.0504042,9.14627403 C15.2504042,8.95627403 15.5614042,8.94627403 15.7604042,9.14627403 C15.9604042,9.33627403 15.9604042,9.65627403 15.7714042,9.84627403 L11.2104042,14.496274 Z",
    id: "Fill-4",
    fill: "#44D7B6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.214cdf83.svg";
export { ForwardRef as ReactComponent };